// Meevo report menu — same names at every clinic. The location code is NOT
// in the menu; it is prefixed only when we look up that clinic's Drive folder.
//
// Owner, 2026-08-21: submenu MEEVO / ME REPORTS / OTHER. MEEVO left-menu
// names supplied as MEVL … and stripped here.

export const REPORT_GROUPS = ['MEEVO', 'ME REPORTS', 'OTHER'] as const;
export type ReportGroup = (typeof REPORT_GROUPS)[number];

export const MEEVO_REPORTS = [
  'DB015 Suspended',
  'DB015 Frozen',
  'DB015 Canceled',
  'DB015 Expiring',
  'DB010 Membership Sales',
  'DB040 EFT Master',
  'DB042 Waived EFT',
  'DB043 EFT Net',
  'MR245 New Members',
  'CF001 Cash Flow',
  'MR035 Discounts',
  'MR041 Service Retail by Employee',
  'MR075 Refunds',
  'MR090 Business Overview',
  'MR240 Daily Deposits',
  'MR260 Sales Trends',
  'CO000 Offsite Transfers',
  'MR118 Client to Client',
  'MR230 Points',
  'AQ065 Confirmations',
  'AQ210 Missed Opportunities',
  'AQ230 Cancellations',
  'MA200 Growth Indicators',
  'MA201 KPI by Month',
  'MA202 Hours to Sell',
  'MI000 Supply Usage',
  'MI020 Inventory Count',
  'MI215 Inventory Snapshot',
  'MES20 Clock Discrepancies',
  'MES01 Weekly Schedules',
  'MES10 Schedule Summary',
  'DE001 Licenses',
  'DB011 Member Non Member',
  'AQ226 Online Booking',
] as const;

export function reportsForGroup(group: ReportGroup): readonly string[] {
  if (group === 'MEEVO') return MEEVO_REPORTS;
  return [];
}

/** Drive folder name for this clinic + menu item. */
export function reportFolderName(locationCode: string, label: string): string {
  return `${locationCode} ${label}`;
}

export function reportFolderResourceKey(clinic: string, group: string, label: string): string {
  return `report-folder:${clinic}:${group}:${label}`;
}

export function reportFavoriteKey(label: string): string {
  return `report.${label.toLowerCase().replace(/\s+/g, '-')}`;
}

export function reportLabelFromKey(itemKey: string): string | null {
  const key = String(itemKey || '').replace(/^#/, '');
  return MEEVO_REPORTS.find((label) => reportFavoriteKey(label) === key) ?? null;
}
